"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVanityName = exports.openExpertInLinkedin = void 0;
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var expert_1 = tslib_1.__importDefault(require("../expert"));
var idb_1 = require("idb");
var uuid = tslib_1.__importStar(require("uuid"));
var REQUESTS_TIMESTAMP = 2500;
var MAX_REQUESTS_EXECUTED = 1;
var RETRY_AFTER = 2;
var wait = function (s) {
    return new Promise(function (resolve) {
        setTimeout(resolve, s * 1000);
    });
};
/**
 * Decide whether to open a linkedin page or not,
 * depending on whether profile update blocks can occur,
 * and whether the expert already has a block in place.
 */
function openExpertInLinkedin(expert, honorProfileUpdateBlock, requestUUID) {
    if (honorProfileUpdateBlock === void 0) { honorProfileUpdateBlock = true; }
    if (requestUUID === void 0) { requestUUID = null; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var db, requestsExecuted, transaction, store, timestamp, deleteKeyRange, requestsToLinkedIn, error_1, vn, blockable;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!requestUUID)
                        requestUUID = uuid.v4();
                    return [4 /*yield*/, (0, idb_1.openDB)('linkedin_ratelimit', 4, {
                            upgrade: function (db) {
                                try {
                                    db.deleteObjectStore('linkedin_ratelimit');
                                }
                                catch (e) { }
                                db.createObjectStore('linkedin_ratelimit', { keyPath: 'timestamp' });
                            },
                        })];
                case 1:
                    db = _a.sent();
                    requestsExecuted = 0;
                    transaction = db.transaction('linkedin_ratelimit', 'readwrite');
                    store = transaction.objectStore('linkedin_ratelimit');
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    timestamp = Date.now() - REQUESTS_TIMESTAMP;
                    deleteKeyRange = IDBKeyRange.upperBound(Number(timestamp - REQUESTS_TIMESTAMP));
                    return [4 /*yield*/, store.delete(deleteKeyRange)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, store.getAll()];
                case 4:
                    requestsToLinkedIn = _a.sent();
                    requestsExecuted = requestsToLinkedIn.length;
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 6:
                    if (!(requestsExecuted >= MAX_REQUESTS_EXECUTED)) return [3 /*break*/, 9];
                    return [4 /*yield*/, wait(RETRY_AFTER)];
                case 7:
                    _a.sent();
                    return [4 /*yield*/, openExpertInLinkedin(expert, honorProfileUpdateBlock)];
                case 8: return [2 /*return*/, _a.sent()];
                case 9: return [4 /*yield*/, store.add({ timestamp: Date.now(), requestUUID: requestUUID })];
                case 10:
                    _a.sent();
                    _a.label = 11;
                case 11:
                    vn = getVanityName(expert);
                    blockable = isProfileUpdateBlockable(expert, vn);
                    if (vn && !vn.explicit) {
                        expert_1.default.updateLinkedinVanityName(expert.id, vn.vanityName);
                    }
                    if (honorProfileUpdateBlock) {
                        if (blockable) {
                            expert_1.default
                                .getProfileUpdateBlock(expert.id)
                                .then(function (result) {
                                if (!result.blocked) {
                                    _openExpertInLinkedin(expert, vn, blockable);
                                }
                            })
                                .catch(function (err) { });
                        }
                        else {
                            _openExpertInLinkedin(expert, vn, blockable);
                        }
                    }
                    else {
                        _openExpertInLinkedin(expert, vn, blockable);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.openExpertInLinkedin = openExpertInLinkedin;
/**
 * Open a linkedin page.  Either the experts actual profile page
 * if they have a vanity name, or a search page if they don't.
 */
function _openExpertInLinkedin(expert, vn, blockable) {
    var baseUrl = window.location.protocol + '//' + window.location.host;
    if (vn) {
        var url = "https://www.linkedin.com/in/".concat(vn.vanityName, "?gtsn=1");
        window.postMessage({ type: 'OPEN_TAB', url: url, tabData: { blockable: false, baseUrl: baseUrl } }, '*');
    }
    else {
        var url = "https://www.linkedin.com/sales/search/people?doFetchHeroCard=true&keywords=".concat(expert.fullName);
        var companyName = getCompany(expert);
        if (companyName) {
            url += " ".concat(companyName);
        }
        window.postMessage({
            type: 'OPEN_TAB',
            url: url,
            tabData: {
                expertId: expert.id,
                expertFullName: expert.fullName,
                blockable: blockable,
                baseUrl: baseUrl,
            },
        }, '*');
    }
}
/**
 * Returns the first company name from the expert's
 * experiences, if available and if not "not specified".
 */
function getCompany(expert) {
    var experiences = (0, get_1.default)(expert, 'cv.experiences', []);
    if (experiences.length) {
        var companyName = (0, get_1.default)(experiences[0], 'company.name', false);
        if (companyName && companyName.toLowerCase() !== 'not specified') {
            return companyName;
        }
    }
    return false;
}
/**
 * If there is an explicit vanity name then profile update cannot be blocked.
 * Otherwise, if they are a Health Care Professional and not in any other
 * sub-industry, then a profile update block is possible.
 */
function isProfileUpdateBlockable(expert, vn) {
    if (vn && vn.explicit) {
        return false;
    }
    var subIndustries = (0, get_1.default)(expert, 'expert.subIndustries', false);
    return subIndustries && subIndustries.length === 1 && subIndustries[0].id === 27;
}
/**
 * Check for an explicit vanity name.
 * If not available, check through professional link urls
 * and grab vanity name from there if possible.
 */
function getVanityName(expert) {
    var vanityName = (0, get_1.default)(expert, 'expert.linkedinVanityName', false);
    if (vanityName) {
        return { vanityName: vanityName, explicit: true };
    }
    var links = (0, get_1.default)(expert, 'links', false);
    if (links && links.length > 0) {
        for (var i = 0; i < links.length; i++) {
            if (links[i].professionalLinkUrl) {
                try {
                    var url = new URL(links[i].professionalLinkUrl);
                    if (url && url.hostname.endsWith('linkedin.com') && url.pathname.startsWith('/in/')) {
                        var parts = url.pathname.split('/');
                        if (parts.length > 2) {
                            vanityName = parts[2];
                            return { vanityName: vanityName, explicit: false };
                        }
                    }
                }
                catch (err) { }
            }
        }
    }
    return false;
}
exports.getVanityName = getVanityName;
